import { useLazyQuery } from "@apollo/client";
import { SupportRequestMessageOriginalQuery } from "../graphql/queries";
import type {
  SupportRequestMessageOriginalQueryType,
  SupportRequestMessageOriginalQueryVariablesType,
} from "@/types/graphql/partner.generated";

export const useSupportRequestMessageOriginalLazyQuery = () =>
  useLazyQuery<
    SupportRequestMessageOriginalQueryType,
    SupportRequestMessageOriginalQueryVariablesType
  >(SupportRequestMessageOriginalQuery, { fetchPolicy: "network-only" });
